import React, { Component } from "react";
import { PageHeader, ListGroup, ListGroupItem } from "react-bootstrap";
import { invokeGetProgramSummary, invokeJoinWorkoutProgram, invokeSetJoinWorkoutProgram } from "../../utils/AwsInvoke";
import LoaderButton                 from "../../components/LoaderButton";
import "../../css/program/ProgramSummary.css";

export default class SubProgram extends Component {
    constructor(props) {
        super(props);

        this.state = {
            program_id: `${this.props.match.params.id}`,
            summary_id: `${this.props.match.params.summary_id}`,
            isLoading: true,
            list: []
        };
    }

    async componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            this.renderSubProgramList();
        } catch (e) {
            alert(e);
        }

        this.setState({ isLoading: false });
    }


    async renderSubProgramList() {
        var program_id  = this.state.program_id;
        var summary_id  = this.state.summary_id;
        var results    = await invokeGetProgramSummary (program_id, summary_id);

        if(results.status)
            this.setState({
                list: results.data
            })
    }

    renderProgramSummary(list) {
        var program_id  = this.state.program_id;

        for(var key in list) {
            var name       = list[0].name;
            var summary    = list[0].summary;
            var total_time = list[0].total_time;
            var calories   = list[0].calories;
            var image   = list[0].image;

            var difficulty_level = list[0].difficulty_level;
            var char_count = difficulty_level.toString().length;
            if(char_count === 1) difficulty_level = difficulty_level + ".0";

            if(image === "") image = "core.jpg";
            

            var programs = <span className="summaryContainer" >
                                    <span className="programSummaryImage">
                                        <img src={require('../../images/program_categories/'+image)}  width="100%"/>
                                    </span>
                                    <span className="programSummaryFadeImage">
                                        <img src={require('../../images/utils/program_category_black_fade.png')} height="60" width="100%"/>
                                    </span>
                                    <span className="programSummaryTitle">{name}</span>
                                    <span className="programSummaryBody">{summary}</span>
                                    <span className="programSummaryTotalTimeBox">
                                        <span className="programSummaryTotalTimeLabel">{total_time}</span>
                                        <span className="programSummaryTotalTimeSubLabel">mins</span>
                                        <div className="circle1"></div>
                                        <span className="programSummaryTotalTime">Total Time</span>
                                    </span>
                                    <span className="programSummaryCalories">
                                        <span className="programSummaryTotalTimeLabel">{calories}</span>
                                        <span className="programSummaryTotalTimeSubLabel">burned</span>
                                        <div className="circle2"></div>
                                        <span className="programSummaryTotalTime">Calories</span>
                                    </span>
                                    <span className="programSummaryDifficultyLevel">
                                        <span className="programSummaryTotalTimeLabel">{difficulty_level}</span>
                                        <span className="programSummaryTotalTimeSubLabel">out of 5</span>
                                        <div className="circle3"></div>
                                        <span className="programSummaryTotalTime">Difficulty</span>
                                    </span>
                                    <div className="programSummaryJoinProgram" > { /*}//href={`/ProgramBegin/${program_id}`}>*/ }

                                         <span onClick={this.handleStartProgram} >
                                            <LoaderButton
                                                //disabled = {}
                                                bsSize   = "large"
                                                width    = "200px"
                                                height   = "40px"
                                                fontSize = "20px"
                                                type     = "submit"
                                                btncolor = "#fcc208"
                                                isLoading={this.state.isLoading}
                                                text="JOIN PROGRAM"
                                                loadingText="Logging in…"
                                              />
                                        </span>
                                          <br/><br/>
                                              <span className="programSummaryLikes">
                                                  <img src={require('../../images/utils/temp_person_likes.png')} height="30"/>
                                              </span>
                                              <br/><br/>
                                    </div>

                                    { /*}<span className="beginBtnFooter"
                                          href={`/ProgramBegin/${program_id}`}
                                          onClick={this.handleStartProgram}>
                                        <span className="glyphicon glyphicon-time beginGlyphIcon"/>START PROGRAM
                                    </span>*/ }
                            </span>
        }

        return programs;
    }

    handleStartProgram = event => {
        event.preventDefault();
        //this.props.history.push(event.currentTarget.getAttribute("href"));

        this.joinProgram();
    }

    joinProgram = async event => {
        var program_id = this.state.program_id;
        var summary_id = this.state.summary_id;
        console.log(">>>>>>>>>>> Join workout program.");
        var results  = await invokeSetJoinWorkoutProgram(program_id, summary_id);

        if(results.status) {
            this.props.history.push(`/ProgramBegin/${program_id}/${summary_id}`);
        }

    }

  renderLander() {
    return (
      <div className="lander">
        <h1>TS</h1>
        <p></p>
      </div>
    );
  }

  renderList() {
    return (
      <div className="list">
          {!this.state.isLoading && this.renderProgramSummary(this.state.list)}
      </div>
    );
  }

  render() {
    return (
      <div className="HomeProgramSummary">
          { this.props.isAuthenticated ? this.renderList() : this.renderLander() }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/program/ProgramSummary.js